import styled from 'styled-components';
import { Palette } from 'config';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: ${Palette.White._000};
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(30, 50, 70, 0.1), 0 1px 2px 0 rgba(30, 50, 70, 0.06);
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${Palette.PrimaryGray._900};
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;

  svg {
    fill: ${Palette.PrimaryGray._400};
  }

  &:hover {
    background-color: ${Palette.PrimaryGray._100};

    svg {
      fill: ${Palette.PrimaryGray._600};
    }
  }
`;

export const ClearAllButton = styled.button`
  padding: 4px 8px;
  border: none;
  background: transparent;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  cursor: pointer;

  &:hover {
    background-color: ${Palette.PrimaryGray._100};
  }

  &:disabled {
    color: ${Palette.PrimaryGray._300};
    cursor: default;
    background-color: transparent;
  }
`;

export const List = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
`;

export const Card = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 24px 32px;

  & + & {
    border-top: 1px solid ${Palette.PrimaryGray._200};
  }
`;

export const Marker = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-top: 4px;
  border-radius: 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.White._000};
  background-color: ${({ $color }) => $color};
`;

export const CardBody = styled.div`
  display: flex;
  flex: 1 0 0;
  align-items: flex-start;
  min-width: 0;
`;

export const CardContent = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.span`
  padding: 2px 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const CardDate = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._400};
`;

export const CardMessage = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
`;

export const CardMeta = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._400};
`;

export const CampaignBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CampaignLabel = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
`;

export const CampaignName = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
`;

export const CampaignId = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 16px;

  span:first-child {
    color: ${Palette.PrimaryGray._500};
  }

  span:nth-child(2) {
    color: ${Palette.PrimaryGray._700};
  }
`;

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const CardLink = styled.a`
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.Primary._500};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 4px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
    fill: ${Palette.PrimaryGray._400};
  }

  &:hover {
    background-color: ${Palette.PrimaryGray._100};

    svg {
      fill: ${Palette.PrimaryGray._600};
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 32px 24px;
  border-top: 1px solid ${Palette.PrimaryGray._200};
`;

export const ShowAllButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 4px 16px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background-color: ${Palette.White._000};
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.05);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.Primary._500};
  cursor: pointer;

  &:hover {
    background-color: ${Palette.PrimaryGray._000};
  }
`;

export const Empty = styled.div`
  display: flex;
  flex: 1 0 0;
  align-items: center;
  justify-content: center;
  padding: 32px;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._400};
`;
